import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next)
  .init({
    lng: 'fr',
    fallbackLng: 'fr',
    debug: false,
    resources: {
      fr: {
        translation: {}
      }
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;